import theme from 'config/theme';

export default {
  wrapper: {
    display: 'flex',
    flexDirection: 'row',
    padding: '12px',
    alignItems: 'center',
    gap: '8px',
    alignSelf: 'stretch',
    color: theme.palette.grays.gray600,
    fontSize: '0.75rem',
    border: `1px solid ${theme.palette.grays.gray100}`,
    borderRadius: '8px',
    justifyContent: 'space-between',
    boxShadow: '0 0 8px 0 rgba(0, 0, 0, 0.12)',
    marginBottom: '20px',
  },
  column: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
    flexGrow: 1,
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: '12px',
    a: {
      color: theme.palette.blues.primaryBlue500,
    },
  },
  title: {
    fontWeight: 600,
    color: theme.palette.grays.gray700,
    fontSize: '1rem',
    marginBottom: '12px',
  },
  name: {
    fontWeight: 700,
    color: theme.palette.grays.gray800,
    fontSize: '0.875rem',
  },
  activeDriverDot: {
    width: '10px',
    height: '10px',
    borderRadius: '50%',
    backgroundColor: theme.palette.greens.green400,
    flexShrink: 0,
  },
  inactiveDriverDot: {
    width: '10px',
    height: '10px',
    borderRadius: '50%',
    backgroundColor: theme.palette.reds.codingRed400,
    flexShrink: 0,
  },
};
